<style lang="less">
@import './style/common/variable';
/* .mzindex {z-index:12000 !important;} */
body {margin: 0px;padding: 0px;height: 100%;overflow: unset !important;}
#app {font-family: 'Avenir', Helvetica, Arial, sans-serif;-webkit-font-smoothing: antialiased;-moz-osx-font-smoothing: grayscale;text-align: center;color: #2c3e50;height: 100%;}
a {text-decoration:none;}
/* scrollbar 滚动条*/
::-webkit-scrollbar{width:8px; height:8px;}
::-webkit-scrollbar-thumb{height:50px; background: #8AB6DD; cursor:pointer; border-radius: 10px;}
::-webkit-scrollbar-track-piece{width:8px; padding: 1px; background-color: #F1F3F4; border: 0px solid #ccc; border-radius: 10px;}
.v-modal {z-index: 1 !important;}
@media screen and (max-width: @max-screen){
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>

<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide()
  {
    return {
      reload: this.reload
    }
  },
  data()
  {
    return {
      isRouterAlive: true
    }
  },
  created()
  {
    //replaceState
    //官方文档就一句话，替换 store 的根状态，仅用状态合并或时光旅行调试。。
    //在页面加载时读取sessionStorage里的状态信息替换store的根状态
    if (sessionStorage.getItem('store'))
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () =>
    {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  mounted()
  {
  },
  methods:
  {
    reload()
    {
      this.isRouterAlive = false
      this.$nextTick(function()
      {
        this.isRouterAlive = true
      })
    },
    _isMobile()
    {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue